import React, { useEffect, useState } from "react";
import RightCard from "./RightCard";
import Styles from "./Styles.module.css";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import CountryModal from "./CountryModal";
import CityModal from "./CityModal";
import MenuApi from "../../../../App/api/menu.apis";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import { toast } from "react-toastify";
import GradientButton from "../../../../Components/Button/GradientButton";

function CountryCity({ meta }) {
  const [isBusiness, setIsBusiness] = useState(false);
  const [selectedCity, setSelectedCity] = useState();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countryData, setCountryData] = useState([]);
  const [cityData, setCityData] = useState([]);

  const [deliveries, setDeliveries] = useState([]);
  const [data1, setData1] = useState([]);
  const [resetForm, setResetForm] = useState(false);
  const [rightTabs, setRightTabs] = useState([
    { tab: "COUNTRY", isActive: true },
    { tab: "CITY", isActive: false },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countryResponse = await MenuApi.getAllCountryInfo();
        setCountryData(countryResponse?.data);

        const cityResponse = await MenuApi.getAllCityInfo();
        setCityData(cityResponse?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Error fetching country or city data");
      }
    };

    fetchData();
  }, []);

  const handleAddCountryData = (newCountry) => {
    setData1((prevData) => [...prevData, newCountry]);
  };

  const handleAddCityData = (newCity) => {
    setCityData((prevCityData) => ({
      data: [...(prevCityData?.data || []), newCity],
    }));
  };

  const handleCity = async (cityData) => {
    console.log("Selected city:", cityData);
    setSelectedCity(cityData);
    console.log("Selected city ID:", cityData);
  };

  const handleSelectedCountry = async (countryData) => {
    console.log("Selected country data :", countryData);
    try {
      const response = await MenuApi.getAllCityInfo(countryData?.country?._id);
      setCityData(response.data);
      setSelectedCountry(countryData);
    } catch (error) {
      console.error("Error fetching country details :", error);
      toast.error("Error fetching country details");
    }
  };

  const handleAddCountryButton = () => {
    setSelectedCountry(null);
    setResetForm(true);
  };

  const handleAddCityButton = () => {
    setSelectedCity(null);
    setResetForm(true);
  };

  return (
    <div className={Styles.dispatchContainer}>
      <div className={Styles.center}>
        <div style={{ height: "100%", padding: "1rem" }}>
          <CommonLayout />

          {/* add country button */}
          {rightTabs[0].isActive && (
            <span className="flex flex-row ml-[50%]  p-2">
              <GradientButton
                type="button"
                label="Add Country"
                onClick={handleAddCountryButton}
              />
            </span>
          )}

          {/* add City button */}
          {rightTabs[1].isActive && (
            <span className="flex flex-row ml-[50%]  p-2">
              <GradientButton
                type="button"
                label="Add City"
                onClick={handleAddCityButton}
              />
            </span>
          )}

          {rightTabs[0].isActive ? (
            <CountryModal
              handleAddCountryButton={handleAddCountryButton}
              selectedCountry={selectedCountry}
              setSelectedCountry={setSelectedCountry}
              setDeliveries={setDeliveries}
              onAddCountry={handleAddCountryData}
              resetForm={resetForm}
            />
          ) : (
            <CityModal
              handleAddCityButton={handleAddCityButton}
              selectedCity={selectedCity}
              selectedCountry={selectedCountry}
              onAddCity={handleAddCityData}
            />
          )}
        </div>
      </div>

      <div className="right">
        <RightCard
          tabs={rightTabs}
          setTab={setRightTabs}
          handleCity={handleCity}
          handleSelectedCountry={handleSelectedCountry}
          cityData={cityData}
          setCityData={setCityData}
          selectedCity={selectedCity}
          selectedCountry={selectedCountry}
          countryData={countryData}
          data1={data1}
          sx={{ borderTopLeftRadius: "10px" }}
        />
      </div>
    </div>
  );
}

export default CountryCity;
